export class Participant {
    id: string;
    type: string;
    condition?: string;
    order: number;
}